'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
interface BroadcastMessage<T> {
  type: T;
  payload?: any;
}
interface UseBroadcastChannelReturn<T> {
  sendMessage: (message: BroadcastMessage<T>) => void;
  receivedMessage: BroadcastMessage<T> | null;
}
function useBroadcastChannel(channelName) {
  const $ = _c(8);
  const [receivedMessage, setReceivedMessage] = useState(null);
  const [channel, setChannel] = useState(null);
  let t0;
  let t1;
  if ($[0] !== channelName) {
    t0 = () => {
      const newChannel = new BroadcastChannel(channelName);
      setChannel(newChannel);
      newChannel.onmessage = event => {
        if (!event.data) {
          return;
        }
        setReceivedMessage(event.data);
      };
      return _temp;
    };
    t1 = [channelName];
    $[0] = channelName;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== channel) {
    t2 = message => {
      channel?.postMessage(message);
    };
    $[3] = channel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sendMessage = t2;
  let t3;
  if ($[5] !== receivedMessage || $[6] !== sendMessage) {
    t3 = {
      sendMessage,
      receivedMessage
    };
    $[5] = receivedMessage;
    $[6] = sendMessage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp() {}
export default useBroadcastChannel;